export interface ManhuaChapter {
  id: string;
  title: string;
  number: number;
  date: string;
}

export interface ManhuaItem {
  id: string;
  slug: string;
  title: string;
  author: string;
  cover: string;
  category: string;
  tags: string[];
  rating: number;
  views: number;
  status: string;
  description: string;
  chapters: ManhuaChapter[];
  updatedAt: string;
  isHot: boolean;
  isNew: boolean;
  isRecommended: boolean;
}

export interface ManhuaCategory {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export interface Testimonial {
  id: string;
  name: string;
  avatar: string;
  role: string;
  rating: number;
  title: string;
  content: string;
}

export const categories: ManhuaCategory[] = [
  { slug: 'all', name: '全部', description: '浏览所有韩国漫画作品，发现你的下一部最爱', icon: 'ri-grid-line' },
  { slug: 'romance', name: '恋爱', description: '甜蜜浪漫的韩国恋爱漫画，心动瞬间不容错过', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻', description: '穿越异世界，魔法与冒险的奇幻韩漫世界', icon: 'ri-magic-line' },
  { slug: 'action', name: '动作', description: '热血战斗，精彩刺激的动作漫画合集', icon: 'ri-sword-line' },
  { slug: 'drama', name: '剧情', description: '深刻动人的剧情漫画，感受人生百态', icon: 'ri-emotion-line' },
  { slug: 'comedy', name: '搞笑', description: '轻松幽默的搞笑漫画，让你开怀大笑', icon: 'ri-emotion-laugh-line' },
  { slug: 'thriller', name: '悬疑', description: '扣人心弦的悬疑推理漫画，烧脑体验', icon: 'ri-search-eye-line' },
  { slug: 'bl', name: 'BL', description: '人气BL漫画作品，甜蜜又心动', icon: 'ri-heart-pulse-line' },
];

export const manhuaList: ManhuaItem[] = [
  {
    id: '1',
    slug: 'wo-de-nan-you-shi-quan-wang-zui-qiang',
    title: '我的男友是全网最强',
    author: '金智恩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20handsome%20young%20man%20with%20dark%20hair%20wearing%20modern%20street%20fashion%20standing%20confidently%20against%20a%20soft%20pastel%20gradient%20background%20with%20cherry%20blossom%20petals%20floating%2C%20romantic%20webtoon%20cover%20art%20style%2C%20clean%20composition%2C%20vibrant%20colors&width=600&height=800&seq=manhua-cover-01&orientation=portrait',
    category: 'romance',
    tags: ['恋爱', '校园', '甜蜜'],
    rating: 9.6,
    views: 12850000,
    status: '连载中',
    description: '平凡的大学生林小夏意外发现自己的男朋友竟然是游戏里那个让所有人闻风丧胆的神秘大神！从此她的生活天翻地覆，甜蜜与爆笑齐飞。全网最强男友，不仅游戏无敌，现实中更是完美男神。一段让人心跳加速的校园恋爱故事，每一话都甜到发齁！',
    chapters: [
      { id: 'c1-1', title: '第1话 意外的发现', number: 1, date: '2025-01-15' },
      { id: 'c1-2', title: '第2话 神秘玩家的真实身份', number: 2, date: '2025-01-22' },
      { id: 'c1-3', title: '第3话 心跳加速的约会', number: 3, date: '2025-01-29' },
      { id: 'c1-4', title: '第4话 全校最强的男友', number: 4, date: '2025-02-05' },
      { id: 'c1-5', title: '第5话 危机降临', number: 5, date: '2025-02-12' },
      { id: 'c1-6', title: '第6话 深夜的秘密', number: 6, date: '2025-02-19' },
      { id: 'c1-7', title: '第7话 无法说出口的心意', number: 7, date: '2025-02-26' },
      { id: 'c1-8', title: '第8话 全校沸腾的表白', number: 8, date: '2025-03-05' },
    ],
    updatedAt: '2026-07-07',
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: '2',
    slug: 'chong-sheng-hou-wo-cheng-le-quan-qiu-shou-fu',
    title: '重生后我成了全球首富',
    author: '朴俊秀',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20featuring%20a%20stylish%20businessman%20in%20a%20luxury%20suit%20standing%20in%20front%20of%20a%20modern%20skyscraper%20cityscape%20at%20sunset%2C%20golden%20hour%20lighting%2C%20dramatic%20composition%2C%20clean%20illustration%20style%2C%20warm%20amber%20tones&width=600&height=800&seq=manhua-cover-02&orientation=portrait',
    category: 'fantasy',
    tags: ['重生', '商战', '逆袭'],
    rating: 9.8,
    views: 25600000,
    status: '连载中',
    description: '前世的穷困潦倒，这一世他要逆天改命！带着前世记忆重生回到二十年前，他凭借对未来经济走势的精确预判，从零开始打造商业帝国。股市、房地产、科技投资，每一步都精准踩中时代风口。当别人还在为生计发愁，他已经站在了世界之巅。',
    chapters: [
      { id: 'c2-1', title: '第1话 重生1999', number: 1, date: '2025-02-01' },
      { id: 'c2-2', title: '第2话 第一桶金', number: 2, date: '2025-02-08' },
      { id: 'c2-3', title: '第3话 股市风云', number: 3, date: '2025-02-15' },
      { id: 'c2-4', title: '第4话 商业帝国的雏形', number: 4, date: '2025-02-22' },
      { id: 'c2-5', title: '第5话 危机与机遇', number: 5, date: '2025-03-01' },
      { id: 'c2-6', title: '第6话 全球瞩目', number: 6, date: '2025-03-08' },
    ],
    updatedAt: '2026-07-06',
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: '3',
    slug: 'an-ying-te-gong',
    title: '暗影特工',
    author: '李玄宇',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20cover%20art%20of%20a%20mysterious%20male%20agent%20in%20a%20black%20tactical%20outfit%20holding%20a%20gun%20with%20dramatic%20lighting%20and%20dark%20urban%20night%20background%2C%20neon%20city%20lights%2C%20cinematic%20composition%2C%20intense%20mood%2C%20sharp%20illustration&width=600&height=800&seq=manhua-cover-03&orientation=portrait',
    category: 'action',
    tags: ['特工', '悬疑', '热血'],
    rating: 9.5,
    views: 18900000,
    status: '连载中',
    description: '他是国家最神秘的特工组织成员，代号"暗影"。一次任务中他发现了惊天阴谋，从此踏上了一条不归路。每一次行动都是生死较量，每一个选择都关乎千万人的命运。当个人信仰与国家利益产生冲突，他将如何抉择？',
    chapters: [
      { id: 'c3-1', title: '第1话 代号暗影', number: 1, date: '2025-03-10' },
      { id: 'c3-2', title: '第2话 潜入敌营', number: 2, date: '2025-03-17' },
      { id: 'c3-3', title: '第3话 绝境求生', number: 3, date: '2025-03-24' },
      { id: 'c3-4', title: '第4话 真相浮现', number: 4, date: '2025-03-31' },
      { id: 'c3-5', title: '第5话 背叛者', number: 5, date: '2025-04-07' },
    ],
    updatedAt: '2026-07-05',
    isHot: true,
    isNew: false,
    isRecommended: false,
  },
  {
    id: '4',
    slug: 'mo-fa-shao-nv-yu-e-long-wang-zi',
    title: '魔法少女与恶龙王子',
    author: '崔秀雅',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%20art%20featuring%20a%20beautiful%20magical%20girl%20with%20long%20flowing%20pink%20hair%20holding%20a%20glowing%20staff%20with%20a%20mysterious%20dragon%20prince%20silhouette%20behind%20her%2C%20magical%20sparkles%2C%20enchanting%20forest%20background%2C%20soft%20dreamy%20atmosphere&width=600&height=800&seq=manhua-cover-04&orientation=portrait',
    category: 'fantasy',
    tags: ['魔法', '恋爱', '冒险'],
    rating: 9.4,
    views: 15200000,
    status: '连载中',
    description: '平凡少女艾琳在一个雨夜救下了一只受伤的小龙，殊不知它竟是龙族的王子！从此她的世界被彻底颠覆，魔法学院、龙族秘宝、千年诅咒，一场跨越种族的奇幻冒险就此展开。友情与爱情交织，魔法与奇迹并存。',
    chapters: [
      { id: 'c4-1', title: '第1话 雨夜来客', number: 1, date: '2025-04-01' },
      { id: 'c4-2', title: '第2话 龙族的秘密', number: 2, date: '2025-04-08' },
      { id: 'c4-3', title: '第3话 魔法学院', number: 3, date: '2025-04-15' },
      { id: 'c4-4', title: '第4话 千年诅咒', number: 4, date: '2025-04-22' },
    ],
    updatedAt: '2026-07-04',
    isHot: false,
    isNew: true,
    isRecommended: true,
  },
  {
    id: '5',
    slug: 'xiao-yuan-ba-wang-de-mi-mi',
    title: '校园霸王的秘密',
    author: '韩美英',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20romance%20cover%20art%20showing%20a%20cool%20male%20student%20with%20slightly%20messy%20hair%20leaning%20against%20a%20school%20locker%20smiling%20mysteriously%2C%20cherry%20blossom%20school%20yard%20background%2C%20warm%20spring%20lighting%2C%20youthful%20and%20fresh%20illustration%20style&width=600&height=800&seq=manhua-cover-05&orientation=portrait',
    category: 'romance',
    tags: ['校园', '恋爱', '青春'],
    rating: 9.3,
    views: 11600000,
    status: '已完结',
    description: '全校闻名的"霸王"金宇贤，打架无人能敌，成绩永远倒数。但他的秘密是——他每天晚上都在一家猫咪咖啡馆打工，而且超级温柔！当这个秘密被同班学霸林小鹿发现后，两人的关系发生了微妙的变化。最反差萌的校园恋爱物语！',
    chapters: [
      { id: 'c5-1', title: '第1话 全校公敌', number: 1, date: '2025-01-20' },
      { id: 'c5-2', title: '第2话 猫咪咖啡馆', number: 2, date: '2025-01-27' },
      { id: 'c5-3', title: '第3话 学霸的秘密笔记', number: 3, date: '2025-02-03' },
      { id: 'c5-4', title: '第4话 心跳的同桌', number: 4, date: '2025-02-10' },
      { id: 'c5-5', title: '第5话 校庆日的告白', number: 5, date: '2025-02-17' },
      { id: 'c5-6', title: '第6话 幸福的开始', number: 6, date: '2025-02-24' },
    ],
    updatedAt: '2026-06-20',
    isHot: false,
    isNew: false,
    isRecommended: true,
  },
  {
    id: '6',
    slug: 'mo-jie-you-xi-zhi-shen',
    title: '魔界游戏之神',
    author: '金泰亨',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20game%20fantasy%20cover%20art%20with%20a%20powerful%20warrior%20character%20wielding%20a%20glowing%20sword%20in%20a%20dark%20dungeon%20setting%2C%20epic%20game-like%20UI%20elements%20floating%20around%2C%20dramatic%20lighting%20from%20above%2C%20intense%20action%20illustration%20style&width=600&height=800&seq=manhua-cover-06&orientation=portrait',
    category: 'action',
    tags: ['游戏', '异世界', '升级'],
    rating: 9.7,
    views: 31200000,
    status: '连载中',
    description: '顶级游戏玩家在攻略最终BOSS时意外穿越到了游戏世界！在这里，他的游戏技巧变成了真实的力量。等级系统、技能树、隐藏任务，一切他都了如指掌。从最底层的新手村到魔界之巅，他将用游戏之神的姿态征服整个世界！',
    chapters: [
      { id: 'c6-1', title: '第1话 穿越游戏世界', number: 1, date: '2025-02-15' },
      { id: 'c6-2', title: '第2话 新手村的隐藏任务', number: 2, date: '2025-02-22' },
      { id: 'c6-3', title: '第3话 S级技能觉醒', number: 3, date: '2025-03-01' },
      { id: 'c6-4', title: '第4话 公会争霸战', number: 4, date: '2025-03-08' },
      { id: 'c6-5', title: '第5话 魔王城攻略', number: 5, date: '2025-03-15' },
      { id: 'c6-6', title: '第6话 传说级装备', number: 6, date: '2025-03-22' },
      { id: 'c6-7', title: '第7话 最终决战', number: 7, date: '2025-03-29' },
    ],
    updatedAt: '2026-07-07',
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: '7',
    slug: 'zong-cai-da-ren-qing-fang-guo-wo',
    title: '总裁大人请放过我',
    author: '张恩淑',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%20art%20featuring%20a%20tall%20handsome%20CEO%20man%20in%20a%20perfect%20suit%20looking%20down%20gently%20at%20a%20shy%20female%20office%20worker%2C%20luxury%20office%20background%20with%20floor%20to%20ceiling%20windows%2C%20elegant%20and%20romantic%20atmosphere&width=600&height=800&seq=manhua-cover-07&orientation=portrait',
    category: 'drama',
    tags: ['总裁', '职场', '虐恋'],
    rating: 9.2,
    views: 9850000,
    status: '连载中',
    description: '普通的小职员苏染染，因为一次意外成为了冷酷总裁陆景琛的私人助理。原以为是噩梦的开始，却不知这是一场精心设计的相遇。霸道总裁的背后隐藏着不为人知的温柔，而她的身世似乎也与陆家有着千丝万缕的联系。',
    chapters: [
      { id: 'c7-1', title: '第1话 意外的相遇', number: 1, date: '2025-03-20' },
      { id: 'c7-2', title: '第2话 私人助理', number: 2, date: '2025-03-27' },
      { id: 'c7-3', title: '第3话 深夜加班', number: 3, date: '2025-04-03' },
      { id: 'c7-4', title: '第4话 总裁的秘密', number: 4, date: '2025-04-10' },
      { id: 'c7-5', title: '第5话 危机四伏', number: 5, date: '2025-04-17' },
    ],
    updatedAt: '2026-07-03',
    isHot: false,
    isNew: true,
    isRecommended: false,
  },
  {
    id: '8',
    slug: 'gao-xiao-shen-tan-shi',
    title: '搞笑神探社',
    author: '赵元昊',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20cover%20art%20showing%20a%20quirky%20detective%20character%20with%20funny%20exaggerated%20expressions%20wearing%20a%20trench%20coat%20and%20holding%20a%20magnifying%20glass%2C%20bright%20colorful%20comic%20style%2C%20playful%20background%20with%20question%20marks%2C%20lighthearted%20illustration&width=600&height=800&seq=manhua-cover-08&orientation=portrait',
    category: 'comedy',
    tags: ['搞笑', '推理', '日常'],
    rating: 9.1,
    views: 8730000,
    status: '连载中',
    description: '一个永远破不了案的侦探，一个超级能吃的美食家助手，还有一只会说话的可疑猫咪。三人组成的侦探社虽然破案率无限接近于零，但笑点密度却高得离谱。每一起"案件"都让人笑到肚子疼，荒诞又温馨的日常推理喜剧！',
    chapters: [
      { id: 'c8-1', title: '第1话 史上最差侦探', number: 1, date: '2025-04-15' },
      { id: 'c8-2', title: '第2话 失踪的蛋糕', number: 2, date: '2025-04-22' },
      { id: 'c8-3', title: '第3话 会说话的猫', number: 3, date: '2025-04-29' },
      { id: 'c8-4', title: '第4话 幽灵公寓事件', number: 4, date: '2025-05-06' },
    ],
    updatedAt: '2026-07-02',
    isHot: false,
    isNew: false,
    isRecommended: false,
  },
  {
    id: '9',
    slug: 'ye-kong-zhi-xia',
    title: '夜空之下',
    author: '刘智雅',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20cover%20art%20featuring%20two%20silhouettes%20sitting%20on%20a%20rooftop%20under%20a%20beautiful%20starry%20night%20sky%2C%20emotional%20atmosphere%2C%20soft%20moonlight%2C%20melancholic%20yet%20beautiful%20illustration%20style%2C%20deep%20indigo%20and%20silver%20color%20tones&width=600&height=800&seq=manhua-cover-09&orientation=portrait',
    category: 'drama',
    tags: ['治愈', '青春', '成长'],
    rating: 9.6,
    views: 7340000,
    status: '已完结',
    description: '三个不同背景的年轻人在城市屋顶相遇，他们各自背负着不为人知的伤痛。每当夜幕降临，他们就在这片属于他们的夜空下分享彼此的故事。友情、梦想、成长的烦恼，在这个小小的屋顶上，他们找到了彼此，也找到了自己。',
    chapters: [
      { id: 'c9-1', title: '第1话 屋顶上的陌生人', number: 1, date: '2025-04-01' },
      { id: 'c9-2', title: '第2话 星星的距离', number: 2, date: '2025-04-08' },
      { id: 'c9-3', title: '第3话 每个人都有自己的故事', number: 3, date: '2025-04-15' },
      { id: 'c9-4', title: '第4话 月光下的约定', number: 4, date: '2025-04-22' },
      { id: 'c9-5', title: '第5话 最后的夜晚', number: 5, date: '2025-04-29' },
    ],
    updatedAt: '2026-06-15',
    isHot: false,
    isNew: false,
    isRecommended: true,
  },
  {
    id: '10',
    slug: 'si-shen-you-xi',
    title: '死神游戏',
    author: '郑允浩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20cover%20art%20depicting%20a%20mysterious%20hooded%20figure%20holding%20a%20glowing%20red%20die%20in%20a%20dark%20alley%2C%20eerie%20atmosphere%2C%20blood%20red%20moon%20in%20background%2C%20psychological%20horror%20illustration%20style%2C%20tense%20mood&width=600&height=800&seq=manhua-cover-10&orientation=portrait',
    category: 'thriller',
    tags: ['悬疑', '生存', '推理'],
    rating: 9.5,
    views: 14500000,
    status: '连载中',
    description: '一百个人被关进了一个神秘的封闭空间，他们必须参加"死神游戏"才能活下去。每轮游戏都有一个致命的规则，违反者将被淘汰——永远地淘汰。谁是幕后黑手？谁又能活到最后？一场关于人性与生存的终极考验。',
    chapters: [
      { id: 'c10-1', title: '第1话 欢迎来到游戏', number: 1, date: '2025-05-01' },
      { id: 'c10-2', title: '第2话 第一轮淘汰', number: 2, date: '2025-05-08' },
      { id: 'c10-3', title: '第3话 信任与背叛', number: 3, date: '2025-05-15' },
      { id: 'c10-4', title: '第4话 隐藏的规则', number: 4, date: '2025-05-22' },
      { id: 'c10-5', title: '第5话 死神的真面目', number: 5, date: '2025-05-29' },
      { id: 'c10-6', title: '第6话 最后的幸存者', number: 6, date: '2025-06-05' },
    ],
    updatedAt: '2026-07-06',
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: '11',
    slug: 'tian-mi-ming-xing-lian',
    title: '甜蜜明星恋',
    author: '尹美娜',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20BL%20romance%20cover%20art%20featuring%20two%20handsome%20young%20male%20idols%20standing%20back%20to%20back%20on%20a%20concert%20stage%2C%20spotlight%20illuminating%20them%2C%20glittering%20stage%20effects%2C%20romantic%20and%20glamorous%20atmosphere%2C%20beautiful%20illustration&width=600&height=800&seq=manhua-cover-11&orientation=portrait',
    category: 'bl',
    tags: ['BL', '娱乐圈', '甜蜜'],
    rating: 9.7,
    views: 20100000,
    status: '连载中',
    description: '当红偶像团体成员李星辰和姜宇轩，舞台上是最佳搭档，舞台下却水火不容。直到一次综艺节目中被迫同居，两人的关系开始悄然改变。从针锋相对到彼此依赖，一段在聚光灯下的秘密恋情悄然展开。',
    chapters: [
      { id: 'c11-1', title: '第1话 舞台上的宿敌', number: 1, date: '2025-05-10' },
      { id: 'c11-2', title: '第2话 被迫同居', number: 2, date: '2025-05-17' },
      { id: 'c11-3', title: '第3话 心动的瞬间', number: 3, date: '2025-05-24' },
      { id: 'c11-4', title: '第4话 深夜的真心话', number: 4, date: '2025-05-31' },
      { id: 'c11-5', title: '第5话 绯闻风暴', number: 5, date: '2025-06-07' },
    ],
    updatedAt: '2026-07-07',
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: '12',
    slug: 'mei-shi-tan-xian-jia',
    title: '美食探险家',
    author: '姜多英',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20food%20comedy%20cover%20art%20featuring%20a%20cheerful%20female%20character%20holding%20chopsticks%20with%20delicious%20Korean%20dishes%20floating%20around%20her%2C%20vibrant%20food%20colors%2C%20warm%20appetizing%20illustration%20style%2C%20mouthwatering%20composition&width=600&height=800&seq=manhua-cover-12&orientation=portrait',
    category: 'comedy',
    tags: ['美食', '旅行', '治愈'],
    rating: 9.0,
    views: 6520000,
    status: '连载中',
    description: '吃货少女小美从一个普通上班族变成了全职美食博主，走遍韩国大街小巷，探寻最地道的美食宝藏。从传统韩食到街头小吃，每一话都是一场味蕾的盛宴。不仅有好吃的，还有暖心的美食故事！看完绝对让你食欲大开！',
    chapters: [
      { id: 'c12-1', title: '第1话 辞职开吃', number: 1, date: '2025-06-01' },
      { id: 'c12-2', title: '第2话 首尔隐藏的炒年糕店', number: 2, date: '2025-06-08' },
      { id: 'c12-3', title: '第3话 釜山的海鲜盛宴', number: 3, date: '2025-06-15' },
    ],
    updatedAt: '2026-07-01',
    isHot: false,
    isNew: false,
    isRecommended: false,
  },
];

export const testimonials: Testimonial[] = [
  {
    id: 't1',
    name: '小王同学',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20young%20female%20avatar%20portrait%20with%20soft%20smile%20and%20warm%20eyes%2C%20simple%20pastel%20background%2C%20clean%20illustration%20style%2C%20half%20body%20portrait&width=120&height=120&seq=avatar-user-01&orientation=squarish',
    role: '忠实读者 · 3年书龄',
    rating: 5,
    title: '漫画质量超级棒！',
    content: '自从发现韩漫网，我的漫画阅读体验完全升级了。画质清晰，翻译精准，更新速度也超快。最喜欢的《暗影特工》每次更新我都第一时间来看，下拉式阅读太方便了！强烈推荐给所有漫画爱好者。',
  },
  {
    id: 't2',
    name: '漫画控阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20young%20male%20avatar%20portrait%20with%20cool%20expression%20and%20stylish%20hair%2C%20simple%20neutral%20background%2C%20clean%20illustration%20style%2C%20half%20body%20portrait&width=120&height=120&seq=avatar-user-02&orientation=squarish',
    role: '漫画达人 · 5年书龄',
    rating: 5,
    title: '海量漫画随心看',
    content: '韩漫网的漫画种类真的很全，从热血动作到甜蜜恋爱应有尽有。分类清晰，找漫画特别方便。而且很多独家作品只有在韩漫网才能看到，已经安利给身边所有朋友了！希望平台越来越好！',
  },
  {
    id: 't3',
    name: '小甜饼爱好者',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20cute%20female%20avatar%20portrait%20with%20bright%20smile%20and%20sparkling%20eyes%2C%20pink%20pastel%20background%2C%20clean%20illustration%20style%2C%20half%20body%20portrait&width=120&height=120&seq=avatar-user-03&orientation=squarish',
    role: '恋爱漫画粉丝 · 2年书龄',
    rating: 5,
    title: '恋爱漫画的天堂！',
    content: '作为一个恋爱漫画重度爱好者，韩漫网简直是天堂！《我的男友是全网最强》甜到我每天追更都停不下来。画风精美，故事动人，每次看完都好想谈恋爱啊～更新速度也很快，完全不用担心追更痛苦！',
  },
  {
    id: 't4',
    name: '深夜读者',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20male%20avatar%20portrait%20with%20glasses%20and%20gentle%20smile%2C%20dark%20warm%20background%2C%20clean%20illustration%20style%2C%20half%20body%20portrait&width=120&height=120&seq=avatar-user-04&orientation=squarish',
    role: '悬疑漫画迷 · 4年书龄',
    rating: 5,
    title: '悬疑类作品太精彩',
    content: '《死神游戏》真的是近年来最好看的悬疑韩漫，剧情紧凑，反转不断。韩漫网的推荐算法也很准，每次推荐的漫画都刚好是我喜欢的类型。下拉式设计在手机上阅读体验一流，睡前必刷！',
  },
  {
    id: 't5',
    name: '宅家小懒猫',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20female%20avatar%20portrait%20with%20sleepy%20cute%20expression%20and%20soft%20features%2C%20light%20yellow%20background%2C%20clean%20illustration%20style%2C%20half%20body%20portrait&width=120&height=120&seq=avatar-user-05&orientation=squarish',
    role: '日常漫画爱好者 · 1年书龄',
    rating: 4,
    title: '每天必刷的漫画网站',
    content: '自从开始用韩漫网，每天都习惯性地打开看看有没有更新。界面简洁好看，没有乱七八糟的广告，阅读体验很纯粹。《搞笑神探社》是我的快乐源泉，每次看都能笑出声。希望多出一些搞笑日常类的漫画！',
  },
  {
    id: 't6',
    name: '漫画收藏家',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20male%20avatar%20portrait%20with%20mature%20look%20and%20confident%20smile%2C%20professional%20background%2C%20clean%20illustration%20style%2C%20half%20body%20portrait&width=120&height=120&seq=avatar-user-06&orientation=squarish',
    role: '漫画评论家 · 6年书龄',
    rating: 5,
    title: '专业漫画平台首选',
    content: '作为一个看了十几年漫画的老读者，韩漫网的质量真的让我惊喜。翻译质量很高，保留了原作的味道。分类系统也很科学，不管是按热度还是按评分排序都能快速找到好作品。期待平台推出更多独家内容！',
  },
];

export const aboutTestimonials: Testimonial[] = [
  {
    id: 'at1',
    name: '韩国漫画协会',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20organization%20logo%20style%20emblem%20with%20Korean%20characters%20and%20comic%20art%20elements%2C%20clean%20design%2C%20prestigious%20look&width=120&height=120&seq=avatar-partner-01&orientation=squarish',
    role: '行业协会',
    rating: 5,
    title: '官方合作伙伴',
    content: '韩漫网作为我们认证的官方合作平台，在漫画版权保护和内容传播方面做出了卓越贡献。平台严格遵守版权规范，为韩国漫画在中国市场的推广起到了重要的桥梁作用。',
  },
  {
    id: 'at2',
    name: '漫画创作人联盟',
    avatar: 'https://readdy.ai/api/search-image?query=Artistic%20organization%20emblem%20with%20pen%20and%20star%20motif%2C%20elegant%20design%2C%20creative%20industry%20look&width=120&height=120&seq=avatar-partner-02&orientation=squarish',
    role: '创作人社区',
    rating: 5,
    title: '创作者推荐平台',
    content: '众多签约漫画家一致推荐韩漫网作为首选发布平台。平台为创作者提供了优质的展示空间和公平的收益分成，让创作者能够专注于创作本身。',
  },
  {
    id: 'at3',
    name: '数字阅读行业联盟',
    avatar: 'https://readdy.ai/api/search-image?query=Digital%20media%20industry%20badge%20with%20modern%20design%2C%20tech%20and%20reading%20elements%2C%20professional%20emblem&width=120&height=120&seq=avatar-partner-03&orientation=squarish',
    role: '行业组织',
    rating: 5,
    title: '年度最佳漫画平台',
    content: '韩漫网连续三年荣获"年度最佳漫画阅读平台"称号。其创新性的下拉式阅读设计引领了行业潮流，用户满意度在同类平台中遥遥领先。',
  },
  {
    id: 'at4',
    name: '内容安全认证中心',
    avatar: 'https://readdy.ai/api/search-image?query=Security%20certification%20badge%20with%20shield%20and%20checkmark%2C%20trustworthy%20design%2C%20clean%20professional%20look&width=120&height=120&seq=avatar-partner-04&orientation=squarish',
    role: '安全认证',
    rating: 5,
    title: '安全阅读环境认证',
    content: '韩漫网通过了严格的内容安全审核认证，为青少年提供了健康、安全的阅读环境。平台的内容分级制度和审核机制得到了业内一致认可。',
  },
  {
    id: 'at5',
    name: '漫画读者协会',
    avatar: 'https://readdy.ai/api/search-image?query=Reader%20community%20badge%20with%20book%20and%20heart%20motif%2C%20warm%20friendly%20design%2C%20community%20focused&width=120&height=120&seq=avatar-partner-05&orientation=squarish',
    role: '读者社群',
    rating: 5,
    title: '读者满意度最高平台',
    content: '在年度读者满意度调查中，韩漫网以98.5%的满意度高居榜首。读者普遍认可平台的漫画质量、更新速度和阅读体验，是漫画爱好者的首选聚集地。',
  },
  {
    id: 'at6',
    name: '国际漫画交流协会',
    avatar: 'https://readdy.ai/api/search-image?query=International%20exchange%20organization%20emblem%20with%20globe%20and%20cultural%20elements%2C%20global%20design%2C%20prestigious%20look&width=120&height=120&seq=avatar-partner-06&orientation=squarish',
    role: '国际交流',
    rating: 5,
    title: '文化交流贡献奖',
    content: '韩漫网在中韩文化交流方面发挥了重要作用，让更多中国读者了解和喜爱韩国漫画文化。平台获得"国际文化交流贡献奖"，受到两国文化部门的高度评价。',
  },
];

export function getManhuaBySlug(slug: string): ManhuaItem | undefined {
  return manhuaList.find((m) => m.slug === slug);
}

export function getManhuaByCategory(categorySlug: string): ManhuaItem[] {
  if (categorySlug === 'all') return manhuaList;
  return manhuaList.filter((m) => m.category === categorySlug);
}

export function getHotManhua(): ManhuaItem[] {
  return manhuaList.filter((m) => m.isHot);
}

export function getRecommendedManhua(): ManhuaItem[] {
  return manhuaList.filter((m) => m.isRecommended);
}

export function getNewManhua(): ManhuaItem[] {
  return manhuaList.filter((m) => m.isNew);
}

export function getTopRatedManhua(limit: number = 10): ManhuaItem[] {
  return [...manhuaList].sort((a, b) => b.rating - a.rating).slice(0, limit);
}

export function getCategoryBySlug(slug: string): ManhuaCategory | undefined {
  return categories.find((c) => c.slug === slug);
}